import * as React from 'react';

import {Link} from 'react-router-dom';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';

import '@app/scss/components/mustheadBadge.scss';

interface MustheadBadgeProps {
	title: string;
	currentPage?: string;
	readMorePath: string;
	readMoreTitle?: string;
	imageSrc: string;
	imageAlt?: string;
}

const arrowIcon = require('@app/images/arrow_circle.svg');

const MustheadBadge: React.FC<MustheadBadgeProps> = props => (
	<div className="musthead musthead_badge">
		<div className="musthead-wrapper">
			<div className="musthead-wrapper-bottom" />
			<div className="musthead-body">
				<div className="musthead-body__left">
					{props.currentPage && <div className="musthead-body__top">{props.currentPage}</div>}
					<h1 className="musthead-body__title">{props.title}</h1>
					<LinkMore linkMoreCaption={props.readMoreTitle ?? 'Read more'} linkMoreLink={props.readMorePath}/>
				</div>
				<img className="musthead-body__image" src={props.imageSrc} alt={props.imageAlt || ''} />
			</div>
		</div>
	</div>
);

export default MustheadBadge;